import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerCategoryCreateScreen from './BannerCategoryCreateScreen'

function BannerCategoryCreate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Tạo mới banner danh mục')} isExist={false} />
        <BannerCategoryCreateScreen/>
    </div>
  )
}

export default BannerCategoryCreate
